import { Component, Input, inject } from '@angular/core';
import { NgIf } from '@angular/common';
import { ShortNumberPipe } from '../../../../pipes/short-number.pipe';
import { SocialCreativeCard } from '../../types';
import { UtilService } from '../../../../services/util.service';
import {AssetVersionPipe} from '../../../../pipes/asset-version.pipe';
import { SocialPlatformIconsComponent } from '../platform-icons/platform-icons.component';

@Component({
    selector: 'app-social-creative-gallery-card',
  imports: [NgIf, ShortNumberPipe, AssetVersionPipe, SocialPlatformIconsComponent],
    templateUrl: './creative-gallery-card.component.html',
    styleUrl: './creative-gallery-card.component.scss',
})
export class SocialCreativeGalleryCardComponent {
    @Input() cardData!: SocialCreativeCard;
    private utilService = inject(UtilService);

    protected hasImageError = false;

    protected get showEmptyCreative(): boolean {
        return this.hasImageError || !this.cardData.creativeUrl;
    }

    protected onImageError(): void {
        this.hasImageError = true;
    }


    public get getDescription(): string {
        return this.cardData.description || "No available description";
    }
    public get hasDescription(): boolean {
        return !!this.cardData.description;
    }

    protected get formattedAdType(): string {
        return this.utilService.formatAdType(this.cardData.adType);
    }

    protected get isVideo(): boolean {
        return this.cardData.isVideo;
    }

    protected get formattedCpm(): string {
        return `$${this.cardData.cpm.toFixed(2)}`;
    }
}
